<app-tab>
  <app-reports-toolbar (generate)="load($event)" [pivotGrid]="grid"></app-reports-toolbar>
  <dx-pivot-grid #grid
                 [allowSortingBySummary]="true"
                 [allowSorting]="true"
                 [allowFiltering]="true"
                 [allowExpandAll]="true"
                 [showBorders]="false"
                 [showColumnGrandTotals]="false"
                 [dataSource]="dataSource">
    <dxo-export [enabled]="true" fileName="les-interventions"></dxo-export>
    <dxo-field-chooser [enabled]="true"></dxo-field-chooser>
  </dx-pivot-grid>
</app-tab>
